import { logout } from "../../../../Redux/custmoer_auth/slice";
import { useAppDispatch } from "../../../../Redux/hooks";
import { useAuth } from "../../../../context/AuthContext";

const AccountMenu = () => {
  const dispatch = useAppDispatch();
  const { isAuthenticated } = useAuth();

  const handleLogout = () => {
    dispatch(logout());
  };

  return (
    <>
      <div className=" display-max">
        <div
          className="dropdown-menu dropdown-menu-two border p-2 min-w-15 border-radius-lg ms-n10"
          aria-labelledby="dropdownMenuButton"
        >
          {isAuthenticated ? (
            <>
              <div className=" lh-base mt-2 dropdown-item border-radius-md mb-1 p-2">
                <a className="" href="/Dashboard">
                  <div className=" d-flex justify-content-lg-start align-items-center gap-1">
                    <div>
                      <li className="avatar avatar-xs">
                        <i className="ri-user-line text-black fs-6"></i>
                      </li>
                    </div>
                    <div>
                      <div>
                        <b className="text-sm fw-normal text-black">My Account</b>
                      </div>
                    </div>
                  </div>
                </a>
              </div>
              <div className=" lh-base mt-1 dropdown-item border-radius-md mb-1 p-2">
                <a className="" href="/MyOrders">
                  <div className=" d-flex justify-content-lg-start align-items-center gap-2">
                    <div>
                      <li className="avatar avatar-xs">
                        <i className="ri-box-3-line text-black fs-6"></i>
                      </li>
                    </div>
                    <div>
                      <div>
                        <b className="text-sm fw-normal text-black">My Orders</b>
                      </div>
                    </div>
                  </div>
                </a>
              </div>
              <div className=" lh-base mt-1 dropdown-item border-radius-md mb-1 p-2">
                <a className="" href="/SalarPay">
                  <div className=" d-flex justify-content-lg-start align-items-center gap-2">
                    <div>
                      <li className="avatar avatar-xs">
                        <i className="ri-wallet-line text-black fs-6"></i>
                      </li>
                    </div>
                    <div>
                      <div>
                        <b className="text-sm fw-normal text-black">My Wallet</b>
                      </div>
                    </div>
                  </div>
                </a>
              </div>
              <div className=" lh-base mt-1 dropdown-item border-radius-md mb-1 p-2">
                <a href="/Wishlist">
                  <div className=" d-flex justify-content-lg-start align-items-center gap-2">
                    <div>
                      <li className="avatar avatar-xs">
                        <a href="/Wishlist">
                          <i className="ri-heart-line text-black fs-6"></i>
                        </a>
                      </li>
                    </div>
                    <div>
                      <div>
                        <b className="text-sm fw-normal text-black">My Wishlist</b>
                      </div>
                    </div>
                  </div>
                </a>
              </div>
              <div className=" lh-base mt-1 dropdown-item border-radius-md mb-1 p-2">
                <a className="" href=".">
                  <div className=" d-flex justify-content-lg-start align-items-center gap-2">
                    <div>
                      <li className="avatar avatar-xs">
                        <a href=".">
                          <i className="ri-rss-line text-black fs-6"></i>
                        </a>
                      </li>
                    </div>
                    <div>
                      <div>
                        <b className="text-sm fw-normal text-black">
                          My Subscriptions
                        </b>
                      </div>
                    </div>
                  </div>
                </a>
              </div>
              <div className=" lh-base mt-1 dropdown-item border-radius-md mb-1 p-2">
                <a className="" href="/ReferralCommission">
                  <div className=" d-flex justify-content-lg-start align-items-center gap-2">
                    <div>
                      <li className="avatar avatar-xs">
                        <i className="ri-layout-grid-line text-black fs-6"></i>
                      </li>
                    </div>
                    <div>
                      <div>
                        <b className="text-sm fw-normal text-black">My Earnings</b>
                      </div>
                    </div>
                  </div>
                </a>
              </div>
              <div className=" lh-base mt-1 dropdown-item border-radius-md mb-1 p-2">
                <a className="" href="/SalarShopVoucher">
                  <div className=" d-flex justify-content-lg-start align-items-center gap-2">
                    <div>
                      <li className="avatar avatar-xs">
                        <i className="ri-ticket-line text-black fs-6"></i>
                      </li>
                    </div>
                    <div>
                      <div>
                        <b className="text-sm fw-normal text-black">My Stuff</b>
                      </div>
                    </div>
                  </div>
                </a>
              </div>
              <div className=" lh-base mt-1 dropdown-item border-radius-md mb-1 p-2">
                <a className="" href=".">
                  <div className=" d-flex justify-content-lg-start align-items-center gap-2">
                    <div>
                      <li className="avatar avatar-xs">
                        <a href="/BrowserHistory">
                          <i className="ri-history-line text-black fs-6"></i>
                        </a>
                      </li>
                    </div>
                    <div>
                      <div>
                        <b className="text-sm fw-normal text-black">
                          Browsing History
                        </b>
                      </div>
                    </div>
                  </div>
                </a>
              </div>
              <div className=" lh-base mt-1 dropdown-item border-radius-md p-2">
                <div className="cursor-pointer" onClick={handleLogout}>
                  <div className=" d-flex justify-content-lg-start align-items-center gap-2">
                    <div>
                      <li className="avatar avatar-xs">
                        <i className=" ri-logout-box-r-line text-black fs-6"></i>
                      </li>
                    </div>
                    <div>
                      <div>
                        <b className="text-sm fw-normal text-black">Logout</b>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          ) : (
            <>
              <div className=" mt-3 mb-1 text-center">
                <div className=" mb-2">
                  <a href="/SignIn">
                    <button className=" btn btn-md btn-dark w-80 fs-6 fw-bolder rounded-pill">
                      Sign in
                    </button>
                  </a>
                </div>
                <div>
                  <a href="/SignUp">Register</a>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default AccountMenu;
